module.exports = __webpack_public_path__ + "img/02.9e38b2a8.jpg";